
<div v-if="hasComments">
    <v-tooltip
        bottom
        content-class="custom-tooltip white"
        :min-width="400"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-icon
                dark
                v-bind = "attrs"
                v-on   = "on"
                class  = "comment"
            >
                fas fa-exclamation-triangle
            </v-icon>
        </template>
        <v-card class="pa-3 pt-2 white primary--text" :elevation="24">
            <div v-if="notes">
                <div class="mt-0">
                    Notizen zur Anlage
                </div>
                <div class="lm-border primary note">
                    <p>{{ notes }}</p>
                </div>
            </div>

            <div v-if="comment" class="mt-3">
                <div class="mt-0">
                    Besonderheiten
                </div>
                <div class="lm-border primary note">
                    <p>{{ comment }}</p>
                </div>
            </div>

            <div v-if="esccomment" class="mt-3">
                <div class="mt-0">
                    Notrufbesonderheiten
                </div>
                <div class="lm-border error note">
                    <p>{{ esccomment }}</p>
                </div>
            </div>

            <div v-if="noticeTlm" class="mt-3">
                <div class="mt-0">
                    Notizen Technischer Liftmanager
                </div>
                <div class="lm-border primary note">
                    <p>{{ noticeTlm }}</p>
                </div>
            </div>
        </v-card>
    </v-tooltip>
</div>
